import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardAvatarInput } from '@trackback/widgets';
import { MatCardAvatar } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'tb-card-avatar',
  imports: [DynamicWidgetDirective],
  template: `
    @for (child of input().children; track $index) {
      <ng-container [dynamicWidget]="child" [context]="context()" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [MatCardAvatar],
  host: {
    '[class]': 'parsedStyleClasses()',
  },
})
export default class CardAvatarComponent extends WidgetInputBaseComponent<CardAvatarInput> {
  parsedStyleClasses = parsed(this.inputProp('styleClasses'), this.context);
}
